import {getSeededRandom} from "../utils/DataUtilities";
import {useContext, useState, useEffect} from "react";
import {StoreContext} from "../stores/StoreLoader";

export function useHeroMediaItem() {
    const {organizationStore} = useContext(StoreContext);
    const [heroItem, setHeroItem] = useState(null);

    useEffect(() => {
        let customHero = organizationStore.hero.filter(media => media.enabled);
        if (customHero?.slice && Array.isArray(customHero.slice()) && customHero.length > 0) {
            // if there are custom media, pick one randomly
            setHeroItem(getSeededRandom(customHero));
        } else if (organizationStore.organization?.media) {
            const media = organizationStore.organization.media;
            setHeroItem(getSeededRandom(media));
        }
    }, [organizationStore.hero]);

    return heroItem;
}
